import { Chart } from "chart.js/auto";
import { LitElement, PropertyValues, css, html } from "lit";
import { customElement, state } from "lit/decorators.js";
import { ref, createRef, Ref } from "lit/directives/ref.js";

const chartConfig = {
    1: {
        type: "bar",
        data: {
            labels: [
                "Manually rejected",
                "Platform rejected",
                "Rejected by authority",
            ],
            datasets: [
                {
                    label: "0-14 days ago",
                    data: [5423, 1021, 422],
                    fill: false,
                    borderWidth: 1,
                    backgroundColor: "rgba(132, 44, 255, 0.7)",
                },
                {
                    label: "15-30 days ago",
                    data: [2420, 624, 322],
                    fill: false,
                    borderWidth: 1,
                    backgroundColor: "rgba(65, 166, 97, 0.7)",
                },
                {
                    label: "> 30 days ago",
                    data: [123, 42, 22],
                    fill: false,
                    borderWidth: 1,
                    backgroundColor: "rgba(255, 99, 132, 0.7)",
                },
            ],
        },
        options: {
            plugins: {
                title: {
                    display: true,
                    text: "Rejected QAs",
                },
            },
        },
    },
    2: {
        type: "bar",
        data: {
            labels: [
                "Manually rejected",
                "Platform rejected",
                "Rejected by authority",
            ],
            datasets: [
                {
                    label: "0-14 days ago",
                    data: [1631, 500, 200],
                    fill: false,
                    borderWidth: 1,
                    backgroundColor: "rgba(132, 44, 255, 0.7)",
                },
                {
                    label: "15-30 days ago",
                    data: [623, 200, 100],
                    fill: false,
                    borderWidth: 1,
                    backgroundColor: "rgba(65, 166, 97, 0.7)",
                },
                {
                    label: "> 30 days ago",
                    data: [612, 123, 42],
                    fill: false,
                    borderWidth: 1,
                    backgroundColor: "rgba(255, 99, 132, 0.7)",
                },
            ],
        },
        options: {
            plugins: {
                title: {
                    display: true,
                    text: "Rejected QABs",
                },
            },
        },
    },
    3: {
        type: "bar",
        data: {
            labels: [
                "Manually rejected",
                "Platform rejected",
                "Rejected by authority",
            ],
            datasets: [
                {
                    label: "0-14 days ago",
                    data: [6423, 1021, 422],
                    fill: false,
                    borderWidth: 1,
                    backgroundColor: "rgba(132, 44, 255, 0.7)",
                },
                {
                    label: "15-30 days ago",
                    data: [2420, 624, 322],
                    fill: false,
                    borderWidth: 1,
                    backgroundColor: "rgba(65, 166, 97, 0.7)",
                },
                {
                    label: "> 30 days ago",
                    data: [123, 42, 22],
                    fill: false,
                    borderWidth: 1,
                    backgroundColor: "rgba(255, 99, 132, 0.7)",
                },
            ],
        },
        options: {
            plugins: {
                title: {
                    display: true,
                    text: "Rejected SB",
                },
            },
        },
    },
};

@customElement("c-platform-rejected")
export class PlatformRejectedWidget extends LitElement {
    static styles = css`
        :host {
            display: block;
            height: 100%;
        }

        select {
            position: absolute;
            right: 0;
        }
    `;

    canvas: Ref<HTMLCanvasElement> = createRef();

    willUpdate(changedProperties: PropertyValues<this>) {
        if (changedProperties.has("selected")) {
            this.loadChart(this.selected);
        }
    }

    currentChart = null;

    loadChart(selected: string) {
        if (this.currentChart) {
            this.currentChart.destroy();
        }

        this.currentChart = new Chart(this.canvas.value, chartConfig[selected]);
    }

    firstUpdated() {
        this.loadChart(this.selected);
    }

    @state()
    selected = "1";

    render() {
        return html`
            <select
                @change=${(e) => {
                    this.selected = e.target.value;
                }}
            >
                <option value="1">QA</option>
                <option value="2">QAB</option>
                <option value="3">SB</option>
            </select>
            <canvas ${ref(this.canvas)}></canvas>
        `;
    }
}
